<template>
  <div class="ua-flag-player-list">
    <div class="box">
      <div class="rugby-nav">
        <div v-for="(item, i) in rugbyTypes" :key="i" class="nav-item">
          <div
            class="nav-btn"
            :class="{ active: item.id === activeId }"
            v-if="(item.val !== '拔旗' && item.val !== '擒抱') || (item.val === '拔旗' && isShowBaqi) || (item.val === '擒抱' && isShowTackle)"
            @click="getBMRugbyMatchPlayerStats(item.id)"
          >
            <span class="zh">{{ item.val }}</span>
            <span class="en">{{ item.english }}</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="table-title">
          <div class="th-rank"></div>
          <div class="th-player">球员</div>
          <div class="th-team">球队</div>
          <div class="th-value">{{ valueColumnTitle }}</div>
        </div>
        <div v-if="rugbyList.length === 0" class="empty">还没有相关赛事数据，组委会正在录入中</div>
        <div v-else>
          <div class="row" v-for="item in rugbyList" :key="item.id">
            <div class="cell rank" :class="{ hot: item.stats.rank < 4 }">{{ item.stats.rank }}</div>
            <div class="cell player overflow-text">{{ item.playerName }}</div>
            <div class="cell team overflow-text">
              <img class="team-logo" :src="filterImage(item.team.badge, 25, 25, 2)" alt="" />
              <span class="overflow-text">{{ item.team.teamAlias || item.team.name }}</span>
            </div>
            <div class="cell value">{{ item.stats.value }}</div>
          </div>
          <div class="match-note">赛事数据统计由组委会提供</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
import { getBMStageGamesByBMMatchId, getBMRugbyMatchPlayerStats, getBMMatchInfo1, getBMShooterScores } from '@/api/match'

export default {
  name: 'UaFlagPlayerListPage',
  data() {
    return {
      matchId: null,
      match: {},
      activeId: 'passTd',
      rugbyList: [],
      isShowBaqi: false,
      isShowTackle: false,
      rugbyTypes: [
        { val: '传球达阵', english: 'PaTD', id: 'passTd' },
        { val: '接球达阵', english: 'RecTD', id: 'recTd' },
        { val: '跑球达阵', english: 'RshTD', id: 'rushTd' },
        { val: '传球码数', english: 'PaYds', id: 'passYds' },
        { val: '接球码数', english: 'ReYds', id: 'recYds' },
        { val: '跑球码数', english: 'RshYds', id: 'rushYds' },
        { val: '抄截', english: 'Int', id: 'int' },
        { val: '拔旗', english: 'Flag Pull', id: 'flagPull' },
        { val: '擒抱', english: 'Tackle', id: 'flagPull' },
        { val: '擒杀', english: 'Sack', id: 'sack' }
      ]
    }
  },
  computed: {
    valueColumnTitle() {
      return this.activeId === 'passYds' || this.activeId === 'recYds' || this.activeId === 'rushYds' ? '码数' : '次数'
    }
  },
  created() {
    this.matchId = this.$route.params.matchId || this.$route.query.matchId
    this.activeId = this.$route.query.type || this.activeId
  },
  mounted() {
    if (!this.matchId) return
    this.getBMMatchInfo1()
    this.getBMStageGamesByBMMatchId()
  },
  methods: {
    getBMStageGamesByBMMatchId() {
      getBMStageGamesByBMMatchId({ matchId: this.matchId }).then(res => {
        const data = res.data
        const unionMatch = res.data.unionMatch
        this.match = data.match || {}
        const nameParts = (this.match.chineseName || '').split('_')
        document.title = (nameParts[1] || '') + '-球员榜'
        const shareObj = {
          title: (nameParts[0] || '') + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: (nameParts[1] || '') + '/球员榜',
          image: QNImageUtil.imageView(this.match.icon)
        }
        this.wxShare(shareObj)

        // 橄榄球分支：保持与原逻辑一致，确保 match 结构完整
        if (this.match.sportType === '橄榄球') {
          const obj = { matchId: this.matchId, bmMatchId: this.matchId, pageSize: 500 }
          getBMShooterScores(obj).then(r => {
            this.match = r.data.match || this.match
          })
          this.getBMRugbyMatchPlayerStats(this.activeId || 'passTd')
        }
      })
    },
    getBMMatchInfo1() {
      getBMMatchInfo1({ matchId: this.matchId, pageSize: 1000 }).then(res => {
        const data = res.data
        const gameType = data.match && data.match.gameType
        this.isShowBaqi = gameType && gameType.indexOf('腰旗') > -1        
        this.isShowTackle = gameType && gameType.indexOf('装备') > -1
      })
    },
    getBMRugbyMatchPlayerStats(id) {
      this.activeId = id
      getBMRugbyMatchPlayerStats({ matchId: this.matchId, pageSize: 500, index: id }).then(res => {
        this.rugbyList = res.data.playerStatsList || []
      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) return '-敬请期待'
      if (currentTime >= startTime && currentTime <= endTime) return '-激战正酣'
      return '-完美闭幕'
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ua-flag-player-list {
  min-height: 100%;
  background: #000;
  color: #fff;
}

.box {
  display: flex;
  min-height: calc(100vh - 80px);
}

.rugby-nav {
  width: 90px;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.08);
  padding: 0;
  box-sizing: border-box;
}

.nav-item {
  margin: 0;
}

.nav-btn {
  position: relative;
  width: 90px;
  height: 66px;
  padding: 18px 10px 14px;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  background: #181818;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: transparent;
  }

  .zh {
    display: block;
    font-size: 14px;
    font-weight: 500;
  }
  .en {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    font-weight: 500;
    opacity: 0.95;
  }

  &.active {
    color: #fff;
    background: #010101;

    &::before {
      background: #ff682c;
    }
  }
}

.right {
  flex: 1;
  min-width: 0;
  padding: 0 18px 24px;
  box-sizing: border-box;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.table-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 0 16px;
  color: #ACACAC;
  font-size: 12px;
  font-weight: 500;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: rgba(255, 255, 255, 0.18);
  }
}

.th-rank {
  width: 44px;
}

.th-player {
  width: 34%;
}

.th-team {
  width: 42%;
}

.th-value {
  width: 18%;
  text-align: right;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  box-sizing: border-box;
}

.cell {
  font-size: 14px;
  color: #fff;
}

.rank {
  width: 44px;
  text-align: left;
  font-weight: 500;
  color: #fff;
  font-size: 14px;

  &.hot {
    color: #ff682c;
    font-size: 16px;
  }
}

.player {
  width: 34%;
  min-width: 0;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 500;
}

.team {
  width: 42%;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 500;
}

.team-logo {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  object-fit: cover;
  flex-shrink: 0;
}

.team span {
  font-size: 13px;
  color: #fff;
}

.value {
  width: 18%;
  text-align: right;
  font-weight: 500;
  font-size: 13px;
  color: #fff;
}

.empty {
  text-align: center;
  padding: 32px 16px;
  font-size: 14px;
  color: #b4b4bf;
}

.match-note {
  font-size: 12px;
  color: #6e6e78;
  text-align: center;
  padding: 16px 8px 0;
}
</style>
